var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.311,
    height: 61.311,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37552",
    transform: "translate(-3549.977 -1896.615)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37551",
    transform: "translate(3549.977 1896.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17551",
    width: 59.742,
    height: 59.742,
    rx: 4,
    transform: "translate(.784 .784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21777",
    d: "M58.77 1.569a.973.973 0 0 1 .972.972V58.77a.973.973 0 0 1-.972.972H2.541a.973.973 0 0 1-.973-.972V2.541a.973.973 0 0 1 .973-.972H58.77m0-1.569H2.541A2.541 2.541 0 0 0 0 2.541V58.77a2.541 2.541 0 0 0 2.541 2.541H58.77a2.541 2.541 0 0 0 2.541-2.541V2.541A2.541 2.541 0 0 0 58.77 0Z",
    fill: "#c3cbd7"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5979",
    cx: 7.071,
    cy: 7.071,
    r: 7.071,
    transform: "translate(3555.261 1902.611)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17552",
    width: 27.371,
    height: 2.84,
    rx: 1.42,
    transform: "translate(3573.516 1905.1)",
    fill: "#2d3e5c"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17553",
    width: 49.863,
    height: 2.84,
    rx: 1.42,
    transform: "translate(3555.261 1923.933)",
    fill: "#1c9f00"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17554",
    width: 49.863,
    height: 2.84,
    rx: 1.42,
    transform: "translate(3555.261 1931.894)",
    fill: "#1c9f00"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17555",
    width: 49.863,
    height: 2.84,
    rx: 1.42,
    transform: "translate(3555.261 1939.855)",
    fill: "#1c9f00"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17556",
    width: 26.958,
    height: 2.84,
    rx: 1.42,
    transform: "translate(3555.261 1947.817)",
    fill: "#1c9f00"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17557",
    width: 12.743,
    height: 2.84,
    rx: 1.42,
    transform: "translate(3573.516 1911.426)",
    fill: "#2d3e5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostcard);
export default __webpack_public_path__ + "static/media/postcard.e8eea9b3157a11b1d8ef2b0a60242ba5.svg";
export { ForwardRef as ReactComponent };